import * as React from "react";
import type { SVGProps } from "react";
const SvgSend01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M21.07 2.93 10.407 13.594M3.27 8.235l16.606-5.761c1.023-.355 2.004.626 1.649 1.649l-5.761 16.606c-.395 1.137-1.992 1.169-2.431.047l-2.637-6.738a1.3 1.3 0 0 0-.735-.735l-6.738-2.637c-1.122-.439-1.09-2.036.047-2.43Z"
    />
  </svg>
);
export default SvgSend01;
